import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { getData } from "../../../api/method";
import "./style.css";

function ProductDescription() {
  const { id } = useParams();

  const [data, setData] = useState([]);

  const getProduct = async () => {
    try {
      const result = await getData(`/api/Product/${id}`);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProduct();
  }, []);

  return (
    <div>
      <div className="mb-2 lh-base d-flex flex-column">
        <div className="fs-20 fw-bold">Category : </div>
        <div className="fs-20">
          <span className="mx-2 t-primary">&#10045;</span>{" "}
          {data?.category?.name}
        </div>
      </div>

      <div className="mb-2 lh-base d-flex flex-column">
        <div className="fs-20 fw-bold">Brand : </div>
        <div className="fs-20">
          <span className="mx-2 t-primary">&#10045;</span> {data?.brand?.name}
        </div>
      </div>

      <div className="mb-2 lh-base d-flex flex-column">
        <div className="fs-20 fw-bold">Product Infomation : </div>

        <div>
          <span className="mx-2 t-primary">&#10045;</span>
          {data.description}
        </div>
      </div>
    </div>
  );
}

export default ProductDescription;
